import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { trpc } from '@/lib/trpc'
import { WorkflowExecutionPage } from '@/pages/docs/components/WorkflowExecutionPage'
import { Loader2 } from 'lucide-react'
import { z } from 'zod/v3';
import { WorkflowDTO } from '@deepguide-ai/types'

// Search params schema
const executionSearchSchema = z.object({
  sessionUrl: z.string().optional(),
  statusId: z.string().optional(),
})

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/workflows/$workflowId/executions/$jobId')({
  component: RouteComponent,
  validateSearch: executionSearchSchema,
})

function RouteComponent() {
  const { workflowId, jobId } = Route.useParams()
  const { sessionUrl, statusId } = Route.useSearch()

  // Fetch workflow data (includes doc with topicId)
  const { data: workflow, isLoading: workflowLoading } = useQuery({
    ...trpc.workflow.getById.queryOptions({ id: workflowId }),
  })

  if (workflowLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
          <p className="text-sm text-gray-600">Loading workflow...</p>
        </div>
      </div>
    )
  }

  if (!workflow) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="text-center">
          <h2 className="text-lg font-semibold text-gray-900">Workflow Not Found</h2>
          <p className="text-sm text-gray-600">The requested workflow could not be found.</p>
        </div>
      </div>
    )
  }

  // Extract topicId from workflow.doc (workflow includes doc with topicId)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const topicId = (workflow as any)?.doc?.topicId
  const topicTitle= (workflow as any)?.doc?.topic?.title
  return (
    <WorkflowExecutionPage
      workflow={workflow as WorkflowDTO}
      jobId={jobId}
      sessionUrl={sessionUrl || null}
      topicId={topicId}
      topicTitle={topicTitle}
      controlEvidenceStatusIdFromSearch={statusId || null}
    />
  )
}
